import { useEffect } from 'react';
import { useToastApiContext } from '@vivli/core/infrastructure/context';

export function useCleanupHook() {
    const toastService = useToastApiContext();

    useEffect(() => {
        return () => {
            toastService.dismiss();
        };
    }, []);
}
